import { render, staticRenderFns } from "./orally_speaking_header.vue?vue&type=template&id=717983b0&scoped=true"
import script from "./orally_speaking_header.vue?vue&type=script&lang=js"
export * from "./orally_speaking_header.vue?vue&type=script&lang=js"
import style0 from "./orally_speaking_header.vue?vue&type=style&index=0&id=717983b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717983b0",
  null
  
)

export default component.exports